import { createIcon } from '../icon'
import RattingMaterialIcon from '@/components/atoms/svg/RattingMaterialIcon'

export const RattingMaterialIconDefault = createIcon(RattingMaterialIcon)
